(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-sports-navigation"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.sports-navigation .navigation-button').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();

    const targetId = this.getAttribute('href').substring(1); // Remove the '#'
    const targetElement = document.getElementById(targetId);

    if (targetElement) {
      window.scrollTo({
        top: targetElement.offsetTop - 50, 
        behavior: 'smooth'
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
